import { api, getQueryString } from "../common/utils"
import { BILLING_CONFIGS_ENDPOINT } from "../common/constants"
import { BillingConfig, BillingConfigDetails } from "../types"

const billingConfig = {
  getByOrgId: async (org_id: string): Promise<BillingConfig[]> => {
    const { data } = await api.get(
      `${BILLING_CONFIGS_ENDPOINT}${getQueryString({ org_id })}`
    )
    return data
  },
  createOrUpdate: async (
    payload: Partial<BillingConfig> & {
      org_id: string
      details: BillingConfigDetails
    }
  ): Promise<{ status: string; message?: string }> => {
    const { data } = await api.post(BILLING_CONFIGS_ENDPOINT, payload)
    return data
  },
  remove: async (id: string): Promise<{ status: string; message?: string }> => {
    const { data } = await api.delete(
      `${BILLING_CONFIGS_ENDPOINT}${getQueryString({ id })}`
    )
    return data
  }
}

export default billingConfig
